// src/swalConfig.js
import Swal from 'sweetalert2';

// Kustomisasi global menggunakan mixin
const swal = Swal.mixin({
  confirmButtonColor: '#0d6ef0', // Warna tombol "OK"
  cancelButtonColor: '#eef2f8', // Warna tombol "Cancel" (abu muda, lihat style/theme.css)
  showCancelButton: true,       // Tampilkan tombol "Cancel" secara default
  showCloseButton: true,
  timer: 3000,                  // Waktu tampil default
});

export default swal;